import React from 'react'

import Link from '@cinch/oxd-components/link/src'

import * as styles from './keywords.module.css'

const KeywordList: React.FC<{ items: string[] }> = ({ items }) => {
  return (
    <ul className={styles.list}>
      {items &&
        items.map((keyword, index) => (
          <li className={styles.item} key={index}>
            <Link className={styles.link} to={`/jargon?q=${keyword}`}>
              {keyword}
            </Link>
          </li>
        ))}
    </ul>
  )
}

export default KeywordList
